import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import RegistrationRequestDetails from '../common/registration/registration-request-details';
import RegistrationRequestChips from '../common/registration/registration-request-chips';
import RequestPreview from '../common/request/request-preview';
import RequestDetailsSkeleton from '../common/skeleton/request-details-skeleton';
import RequestInfoSkeleton from '../common/skeleton/request-info-skeleton';
import OfferInfo from '../common/offer-info';
import { Panel, PanelHeader, PanelContent } from '../common/panel';

import { renderAttachment } from '../../../helpers/attachment-helper';
import { checkTokenExpirationMiddleware } from '../../../middlewares/users-auth.middleware';

const RegistrationOffer = () => {
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loading, setLoading] = useState({
        skeleton: true,
        backdrop: false
    });
    const [registrationOffer, setRegistrationOffer] = useState(null);
    const [, setError] = useState(null);
    const { id } = useParams();
    let history = useHistory();

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };

    useEffect(() => {
        axios.get(`/api/registrationoffer/${id}`, { headers: headers })
            .then(res => {
                setRegistrationOffer(res.data);
                setTimeout(() => setLoading({ ...loading, skeleton: false }), 500);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [])

    const deleteOffer = () => {
        setLoading({ ...loading, backdrop: true });
        axios.delete(`/api/registrationoffer/${id}`, { headers: headers })
            .then(res => {
                setTimeout(() => history.push(`/request/${registrationOffer.reservationRequestResource.id}/registration`), 500);

            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }

    return (
        <>
            {
                loading.backdrop ?
                    <Backdrop className="backdrop" open={loading.backdrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    :
                    null
            }
            <Grid container spacing={3}>
                <Grid
                    container item xs={12} md={12} lg={9}
                >
                    <Panel>
                        <PanelHeader>Request Details</PanelHeader>
                        <PanelContent>
                            {loading.skeleton ?
                                <RequestDetailsSkeleton />
                                :
                                registrationOffer ?
                                    <>
                                        <RequestPreview
                                            label={"Registration"}
                                            keyword={"Cities"}
                                            reservationRequest={registrationOffer.reservationRequestResource}
                                            Details={
                                                <RegistrationRequestDetails
                                                    registrationResources={registrationOffer.reservationRequestResource.reservationRequestRegistrationResources}
                                                />
                                            }
                                            Chips={
                                                <RegistrationRequestChips
                                                    variant={"default"}
                                                    registrationResources={registrationOffer.reservationRequestResource.reservationRequestRegistrationResources}
                                                />
                                            }
                                        />
                                    </>
                                    : null
                            }
                        </PanelContent>
                    </Panel>

                    <Panel>
                        <PanelHeader>Offer Details</PanelHeader>
                        <PanelContent>
                            {loading.skeleton ?
                                <RequestDetailsSkeleton />
                                :
                                registrationOffer ?
                                    <>
                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Destination:
                                                    </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {registrationOffer.destinationName}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Registration Type:
                                                    </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {registrationOffer.registrationType}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Price:
                                                    </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {registrationOffer.registrationPrice} L.E.
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Due Date:
                                                    </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {registrationOffer.registrationDueDate.substring(0, 10)}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Requirements:
                                                    </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {registrationOffer.registrationRequirements}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={12} md={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Notes:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {registrationOffer.notes}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Attachment:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {renderAttachment(registrationOffer.attachment)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </>
                                    : null
                            }
                        </PanelContent>
                    </Panel>
                </Grid>

                <Grid
                    container item xs={12} md={12} lg={3}
                >
                    <div className="side-info">
                        {
                            loading.skeleton ?
                                <RequestInfoSkeleton />
                                :
                                registrationOffer ?
                                    <OfferInfo offer={registrationOffer} deleteOffer={deleteOffer} />
                                    : null
                        }
                    </div>
                </Grid>
            </Grid>
        </>
    );
}

export default RegistrationOffer;